import * as auth from "./auth";
import * as credit from "./credit";
import * as products from "./products";
import * as dashboard from "./dashboard";
import * as sites from "./sites";
import * as sellers from "./sellers";
import * as company_employee from "./company_employee";
import * as drivers from "./drivers";
import * as cars from "./cars";
import * as order_report from "./order_report";

export const realList = {
  auth,
  dashboard,
  credit,
  products,
  sites,
  sellers,
  company_employee,
  drivers,
  cars,
  order_report
};
